export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12199.4b9ac589.jpg";